import { Swiper, SwiperSlide } from 'swiper/react';
import { useProductImages } from '../hooks/useProductImages';
import ProductImageTag from './ProductImageTag';

import SwiperCaretNext from './SwiperCaretNext';
import SwiperCaretPrev from './SwiperCaretPrev';

type ProductImagesGallerySwiperContainerProps = {
	thumbController: any;
	images: any;
};

const ProductImagesGallerySwiperContainer = ({ thumbController, images }: ProductImagesGallerySwiperContainerProps) => {
	const { blockClass, showPaginationDots, showNavigationArrows } = useProductImages();

	const pagination = {
		el: `.swiper-pagination-bullets`,
		clickable: true,
		bulletClass: 'vtex-store-components-3-x-swiperBullet swiperBullet',
		bulletActiveClass: 'vtex-store-components-3-x-swiperBullet--active swiperBullet--active',
		renderBullet(index: number, className: string) {
			return `<span class="${className} c-action-primary ${index == 0 ? 'vtex-store-components-3-x-swiperBullet--active swiperBullet--active' : ''}"></span>`;
		},
	};

	const navigation = {
		prevEl: '.swiper-caret-prev',
		nextEl: '.swiper-caret-next',
		disabledClass: `c-disabled`,
	};

	const renderClass = () => {
		return blockClass && `vtex-store-components-3-x-productImagesGallerySwiperContainer--${blockClass}`;
	};

	return (
		<Swiper
			thumbs={{
				swiper: thumbController,
				slideThumbActiveClass: 'vtex-store-components-3-x-productImagesThumbActive productImagesThumbActive',
			}}
			className={`productImagesGallerySwiperContainer productImagesGallerySwiperContainer--${blockClass} vtex-store-components-3-x-productImagesGallerySwiperContainer ${renderClass()}`}
			threshold={10}
			resistanceRatio={images.length > 1 ? 0.85 : 0}
			updateOnWindowResize
			navigation={navigation}
			pagination={!showPaginationDots || pagination}
		>
			{images.map((img: any, index: any) => (
				<SwiperSlide
					key={`gallery-${index}`}
					className={`productImagesGallerySlide productImagesGallerySlide--${blockClass} swiper-slide center-all`}
				>
					<ProductImageTag src={img} />
				</SwiperSlide>
			))}
			{/* fix pois nao está aparecendo as bolinhas dentro do iframe */}
			{showPaginationDots && (
				<div
					key="pagination"
					className={
						'swiper-pagination swiperPaginationClickable swiper-pagination-bullets vtex-store-components-3-x-swiper-pagination vtex-store-components-3-x-swiperPaginationClickable swiper-pagination-bullets'
					}
				>
					<span className="vtex-store-components-3-x-swiperBullet swiperBullet c-action-primary vtex-store-components-3-x-swiperBullet--active swiperBullet--active"></span>
					<span className="vtex-store-components-3-x-swiperBullet swiperBullet c-action-primary "></span>
				</div>
			)}

			{showNavigationArrows && (
				<div>
					<SwiperCaretNext />
					<SwiperCaretPrev />
				</div>
			)}
		</Swiper>
	);
};

export default ProductImagesGallerySwiperContainer;
